import type { FC } from 'react';
import Image from '../../../../shared/components/Image';
import { VIP_BADGE_ASSET, getJackpotLevelLabelAsset, isVipJackpot } from '../../statisticsAssets';
import { formatJackpotLevelLabel, normalizeJackpotLevelName } from '../../utils/jackpotStatistics';
import styles from './JackpotStatistics.module.css';

interface JackpotLevelLabelProps {
  jackpotName: string;
  /** The DISPLAY level name — `Grand`, `Major`, `Super`, … */
  levelName: string;
  withVipBadge?: boolean;
}

const JackpotLevelLabel: FC<JackpotLevelLabelProps> = ({ jackpotName, levelName, withVipBadge = false }) => {
  const label = formatJackpotLevelLabel(levelName);
  const asset = getJackpotLevelLabelAsset(jackpotName, levelName);
  const showVipBadge = withVipBadge && isVipJackpot(jackpotName);

  return (
    <>
      {showVipBadge && <Image src={VIP_BADGE_ASSET} alt="VIP" className={styles.vipBadge} />}
      {asset ? (
        <Image src={asset} alt={label} className={styles.levelLabelImg} />
      ) : (
        <span className={styles.levelLabelText} data-level={normalizeJackpotLevelName(levelName)}>
          {label}
        </span>
      )}
    </>
  );
};

export default JackpotLevelLabel;
